/*
 * @Author: Merlin
 * @Date: 2025-03-19 10:08:42
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-19 11:00:47
 * @Description: 
 */

export const dropDownOptions = [
    {
        value: 1,
        name: 1,
    },
    {
        value: 2,
        name: 2,
    },
    {
        value: 3,
        name: 3,
    },
    {
        value: 4,
        name: 4,
    },
];
export const roundData = {
    level: 0,
    field: [[] as number[]],
    multi: null,
    revealed: [],
    status:''
};
// 规则数据
export const stairsRulesData = [
    {
        content1: 'GameStairs.Rule1',
        constent2: '',
    }
];


export enum BetTypeEnum {
    StartBet = 0,
    NextBet = 1,
    CashOut = 2,
}